import React, { useState, useEffect } from 'react';
import './EditableField.css';

const EditableField = ({ path, value, updateCharacter, type = 'text' }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const handleFocus = (e) => {
    e.target.select();
  }

  const handleBlur = () => {
    setIsEditing(false);
    updateCharacter(path, currentValue);
  };

  const handleChange = (e) => {
    setCurrentValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  }

  return (
    <div className="editable-field" onClick={() => setIsEditing(true)}>
      {isEditing ? (
        <input
          type={type}
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          autoFocus
        />
      ) : (
        <div className="value">{value}</div>
      )}
    </div>
  );
};

export default EditableField;
